import type { ReactNode } from 'react';
import styles from './ui.module.css';

/** Ряд чипов с переносом: личные метки предмета и фильтр над складом. */
export function ChipRow({
  children,
  trailing,
}: {
  children: ReactNode;
  /**
   * Знак у ПРАВОГО края ряда. Состояние анкеты стоит там же, где состояние в
   * карточке списка: прижатым, а не следом за метками. Метки говорят, ЧТО это
   * за персонаж, знак — что с его анкетой, и мешать их в одну строку подряд
   * значит потерять и то и другое.
   */
  trailing?: ReactNode;
}) {
  return (
    <div className={styles.chipRow}>
      {children}
      {trailing === undefined ? null : <span className={styles.chipRowTrailing}>{trailing}</span>}
    </div>
  );
}
